/** Sentinel for month-index filters: no single month — show full selected year. */
export const ALL_LIST_MONTHS = -1;

/** GST table filter: 0 = all months in year; 1–12 = calendar month. */
export const ALL_GST_MONTHS = 0;

/**
 * GST year filter: 0 = all years (used when drilling from summary KPI cards
 * whose counts are all-time).
 */
export const ALL_GST_YEARS = 0;

/** Default list period: current calendar month (0–11) in the current year. */
export function getDefaultListPeriod(referenceDate: Date = new Date()): {
  year: number;
  month: number;
} {
  return {
    year: referenceDate.getFullYear(),
    month: referenceDate.getMonth(),
  };
}

/** GST month picker uses 1–12 for months; 0 = all months in the selected year. */
export function getDefaultGstMonth(referenceDate: Date = new Date()): number {
  return referenceDate.getMonth() + 1;
}

/** True when filters match the default current-month view (no custom date range). */
export function isDefaultListPeriod(
  year: number,
  month: number | null,
  startDate: string,
  endDate: string,
  referenceDate: Date = new Date()
): boolean {
  if (startDate || endDate) return false;
  const { year: defaultYear, month: defaultMonth } =
    getDefaultListPeriod(referenceDate);
  if (year !== defaultYear) return false;
  return month === defaultMonth;
}

/** GST pages use 0 for “all months” instead of -1 / null. */
export function isDefaultGstListPeriod(
  year: number,
  month: number,
  referenceDate: Date = new Date()
): boolean {
  if (year === ALL_GST_YEARS) return false;
  const { year: defaultYear } = getDefaultListPeriod(referenceDate);
  return year === defaultYear && month === getDefaultGstMonth(referenceDate);
}

/** @deprecated Use ALL_LIST_MONTHS */
export const ALL_TRANSACTION_MONTHS = ALL_LIST_MONTHS;

/** @deprecated Use getDefaultListPeriod */
export const getDefaultTransactionListPeriod = getDefaultListPeriod;

/** @deprecated Use isDefaultListPeriod */
export const isDefaultTransactionListPeriod = isDefaultListPeriod;
